const EMAIL_REGEX = /^\S+@\S+$/;

export { EMAIL_REGEX };
